// TODO: delete this file when tracking is fully migrated to ui-shepherd-react
export const APP = 'onboarding-tours';
export const EVENTS = {
  TOUR_CLOSE: 'tourClose',
  TOUR_FINISH: 'tourFinish',
  TOUR_START: 'tourStart',
  TOUR_VIEW_STEP: 'tourViewStep',
  TOUR_VIEW_FINISH_MODAL: 'tourViewFinishModal',
  TOUR_VIEW_CLOSE_MODAL: 'tourViewCloseModal',
  TOUR_CLICK_EXTERNAL_STEP_LINK: 'tourClickExternalStepLink'
};